(function () {
    'use strict';
    angular
        .module('app.widgets')
        .directive('selectsCascade', selectsCascade)
        .directive('selectCascade', selectCascade);


    function selectsCascade(){
        return {
            restrict:'A',
            scope:{
                options:'=?',
                keyToNameOptions:'=?',
                cascadeOptions:'=',
                cascadeOrder:'='
            },
            controller: selectsCascadeCtrl,
            controllerAs:'vm',
            bindToController:true,
            link: function (scope) {
                scope.vm.initState();
            }
        };

        /*@ngInject*/
        function selectsCascadeCtrl(){
            var vm = this;
            vm.registeredSelects = {}; // contain the list of select to register
            vm.registerSelect = registerSelect;
            //vm.setSubOption = setSubOption;
            vm.state = {};
            vm.initState = initState;
            vm.setSelectedKey = setSelectedKey;

            function registerSelect(name, controller){
                if(name && controller){
                    if (! vm.registeredSelects) {
                        vm.registeredSelects = {};
                    }
                    vm.registeredSelects[name] = controller;
                }
            }

            function setSelectedKey(cascadeName, keyValue){
                //set key
                setStateCurrentKey(cascadeName, keyValue);
                updateState();
            }

            function initState(){
                //vm.cascadeOrder
                //vm.cascadeOptions

                //set the first cascade data
                vm.state = vm.state || {};
                if(angular.isArray(vm.cascadeOrder)){

                    vm.cascadeOrder.forEach(function(itemName){


                        vm.registeredSelects[itemName].setHidden(false);
                        vm.state[itemName]={name:itemName, options:[], selected:vm.registeredSelects[itemName].bindModel, cascade:null}
                    });

                    //var firstCascadeName = vm.cascadeOrder[0];
                    //if(firstCascadeName){
                    //    cascade_set_option(firstCascadeName,cascadeOptions);
                    //    vm.state[firstCascadeName].options = vm.cascadeOptions;
                    //}
                }

                updateState();
            }

            function cascade_set_option(cascadeName, cascadeOptions){

                vm.registeredSelects[cascadeName].setOptions(cascadeOptions);
            }

            function state_reducer(cascadeOptions, cascadeName){
                //set option and check if selected key is valid for a state

                //var demo = [{value:1, options:[{value:10, options:[]}, {value:11, options:[]} ]}];

                //set the options for a given State
                cascade_set_option(cascadeName, cascadeOptions);

                // find if current value is valid
                var isSelectedKeyValid = null;
                if(angular.isArray(cascadeOptions)){
                    isSelectedKeyValid = _.find(cascadeOptions, function(item){
                        return item.value == vm.state[cascadeName].selected;
                    });
                }

                //set current selected value to null if we can't find the value:
                if (! isSelectedKeyValid){ //reset current key value if not valid
                    vm.state[cascadeName].selected = null;
                    return null;
                }else{
                    var currentKey = vm.state[cascadeName].selected;
                    //return new options  for next nested cascade
                    return isSelectedKeyValid.options || null;
                }
            }

            /**
             * update the state
             */
            function updateState(){
                if(angular.isArray(vm.cascadeOrder)){
                    vm.cascadeOrder.reduce(state_reducer, vm.cascadeOptions);
                }
            }


            //for (var i=0,  size=vm.keyToNameOptions[vm.name].length; i < size; i++) {
            //    var element = vm.keyToNameOptions[vm.name][i];
            //    if( element.KEY  == vm.bindModel){
            //        vm.e =element;
            //        return element.onSelect.items;
            //    }
            //}

            /**
             * find the cascade state and set his current key an
             * @param cascadeName
             * @param keyValue
             */
            function setStateCurrentKey(cascadeName, keyValue){
                vm.state[cascadeName].selected = keyValue;
            }
        }
    }

    function selectCascade(){
        return {
            restrict:'E',
            scope:{
                name:'@',
                keyToNameOptions:'=?',
                bindModel:'=ngModel',
                status:'=?',
                placeholder:'@?'
            },
            controller:selectCascadeCtrl,
            controllerAs:'vm',
            bindToController:true,
            link: selectCascadeLinkFn,
            require:'^selectsCascade',
            template:'<select class="form-control"\n        id="vm.name"\n        ng-hide="vm.status.hidden"\n        ng-disabled="!vm.options"\n        ng-model="vm.bindModel"\n        ng-change="vm.onChange()"\n        ng-selected = "vm.bindModel = vm.bindModel ||  vm.default_option"\n        ng-options="option.value as vm.getOptionByKey(option.value) for option in vm.options"\n        ng-required="vm.isRequired">\n    <option value="" ng-if="vm.placeholder">{{vm.placeholder}}</option>\n</select>'
        };

        /*@ngInject*/
        function selectCascadeCtrl(){
            var vm = this;
            vm.status = vm.status || {hidden: true};
            vm.selected = {};
            vm.masterController = null;
            vm.options = null;
            vm.setMasterController = setMasterController;
            vm.setOptions = setOptions;
            vm.setHidden = setHidden;
            vm.onChange = onChange;
            vm.getOptionByKey = getOptionByKey;

            updateStatus();

            function setHidden(isHidden){
                vm.status.hidden = isHidden;
            }
            function setOptions(options){
                updateStatus();
                vm.options = options;
            }

            function setMasterController(masterCtrl){
                vm.masterController = masterCtrl;
            }

            function onChange(){
                updateStatus();
                //getOptionByKey();
                if(vm.masterController){
                    vm.masterController.setSelectedKey(vm.name, vm.bindModel);
                }
            }
            function getOptionByKey(keyForValueToFind){
                if(angular.isArray(vm.keyToNameOptions)){
                    var result = _.find(vm.keyToNameOptions, function(item){
                        return item.KEY == keyForValueToFind;
                    });
                    return result && result.VALUE ? result.VALUE : keyForValueToFind;
                }
                return keyForValueToFind;
            }

            function updateStatus(){
                //update the status
                vm.status.enabled = (angular.isArray(vm.options) && vm.options.length > 0)
                || (angular.isObject(vm.options) && Object.keys(vm.options).length > 0 ? true : false);
            }
        }

        function selectCascadeLinkFn(scope, element,attributes, selectsCascadeController){
            if(selectsCascadeController){
      
                selectsCascadeController.registerSelect(scope.vm.name, scope.vm);
                scope.vm.setMasterController(selectsCascadeController);
            }
        }
    }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-select-cascade.js
 ** module id = 192
 ** module chunks = 0
 **/